(function () {
  'use strict';

  angular.module('wsLrs.services').
  /**
   * A place for chart-related utility functions.
   */
  factory('ChartUtils', ['screenSize', 'wsColors', 'wsConstants', 'OrganizationSettings', function (screenSize, wsColors, wsConstants, OrganizationSettings) {
    return {
      getEmptyChart: function getEmptyChart() {
        return {
          chart: {
            backgroundColor: wsColors.wsBlueLighter,
            borderRadius: 0
          },
          lang: {
            noData: "There is no data to<br />power this report yet."
          },
          title: "",
          noData: {
            style: {
              fontFamily: wsConstants.fontStack.body,
              fontSize: '14px',
              fontWeight: 'normal'
            }
          }
        };
      },
      // used to get a last line of label when middle lines have been omitted.
      // get the end of label, up to maxChars, separated by space, non-alphanumeric chars, or maxChars.
      getLastLineOfLabel: function getLastLineOfLabel(label, maxChars) {
        var filter = new RegExp("(?:(?:[\\s\\S]*?)(?:^|\\s|[^a-zA-Z0-9\"\'])|(?:^|[\\s\\S]+?))(.{1," + maxChars + "}$)");
        return _.last(filter.exec(label));
      },
      // Calculates a chart range from stats & benchmark info
      // Params:
      //  stats: the transformer-produced stats array for each measure
      //  benchmarks: optional, either the config.measures array, or a single benchmark value
      //  defRange: optional, default range object
      //  prec: optional, number of decimal places to consider - defaults to 0.
      // Returns:
      //  range object: {min: min_value, max: max_value}
      getRange: function getRange(stats, measures, defRange, prec) {
        // todo: check for 'Score' or 'Percentage' type and return {min: 0, max: 100}

        stats = stats || [];
        measures = angular.isDefined(measures) ? measures : [];
        var benchmark = !angular.isArray(measures) && Number.isFinite(measures) ? {
          value: measures
        } : null;
        prec = prec || 0;
        var range = defRange || {};
        _.each(stats, function (stat, i) {
          var min = _.isNumber(stat.min) ? Math.round(stat.min, prec) : null;
          var max = _.isNumber(stat.max) ? Math.round(stat.max, prec) : null;
          var bmark = measures[i] ? measures[i].benchmark : benchmark;
          if (bmark && angular.isDefined(bmark.value)) {
            min = angular.isDefined(min) ? Math.min(bmark.value, min) : bmark.value;
            max = angular.isDefined(max) ? Math.max(bmark.value, max) : bmark.value;
          }
          range.min = angular.isDefined(range.min) ? Math.min(min, range.min) : min;
          range.max = angular.isDefined(range.max) ? Math.max(max, range.max) : max;
        });
        range.min = Math.floor(range.min, prec);
        range.max = Math.ceil(range.max, prec);
        return range;
      },
      // get value of a SIMPLE value object (on Measures)
      getSimpleValue: function getSimpleValue(valueObject) {
        if (valueObject && valueObject.type === 'SIMPLE') {
          var value = parseFloat(valueObject.value);
          if (typeof value === 'number' && !isNaN(value)) {
            return value;
          }
        }
        return null;
      },
      // "hard" set the axis min from measure-based min option
      setAxisMin: function setAxisMin(min, yAxis) {
        var value = this.getSimpleValue(min);
        if (value !== null) {
          yAxis.min = _.isFinite(yAxis.min) ? Math.min(yAxis.min, value) : value;
        }
      },
      // "hard" set the axis max from measure-based min option
      setAxisMax: function setAxisMax(max, yAxis) {
        var value = this.getSimpleValue(max);
        if (value !== null) {
          yAxis.max = _.isFinite(yAxis.max) ? Math.max(yAxis.max, value) : value;
        }
      },
      //lineLen: specifies number of characters per line (default: 24)
      //linesMobile: specifies number of lines to show when device is phone (default: 2)
      //linesDefault: specifies number of lines to show when device is not a phone (default: 2)
      formatCategories: function formatCategories(value, lineLen, linesMobile, linesDefault) {
        if (_.isUndefined(value) || _.isNull(value)) {
          return null;
        }
        var lineLength = lineLen || 24,
          matches = this.separateLabelIntoLines(value, lineLength),
          lastLine = _.last(matches),
          maxLines = screenSize.is('xs') ? linesMobile || 2 : linesDefault || 2,
          results = "";

        // prevent breaking just a few chars onto last line
        var numMatches = matches.length;
        if (numMatches > 1 && _.last(matches).length < 6) {
          matches[numMatches - 2] += matches[numMatches - 1];
          matches.pop();
        }

        // format results with some removed
        if (matches.length > maxLines) {
          if (maxLines === 1) {
            // prevent removing less than 5 chars
            if (value.length <= lineLength * 2 + 5) {
              return value;
            }
            return matches[0] + (matches.length > 2 ? ' ... ' : '') + lastLine;
          } else {
            for (var i = 0; i < maxLines - 1; i++) {
              results += matches[i] + (i === maxLines - 2 ? '...' : '') + '<br/>';
            }
            return results + '...' + lastLine;
          }
        }

        // return all text broken into lines
        return matches.join('<br/>');
      },
      formatAxisLabels: function formatAxisLabels(axisLabels) {
        if (!axisLabels.style) {
          axisLabels.style = {};
        }
        axisLabels.rotation = -90;
        axisLabels.style.fontSize = '10px';
        axisLabels.style.lineHeight = '10px';
      },
      // will divide label at word end, up to maxChars,
      // or divide at non-alphanumeric character, up to max characters,
      // or split an alphanumeric word that is longer than max characters.
      separateLabelIntoLines: function separateLabelIntoLines(label, maxChars) {
        var filter = new RegExp("(.{1," + maxChars + "})(\\s|[^a-zA-Z0-9\"\'&#;]|$)+" + "|([\\s\\S]{1," + maxChars + "})", "g");
        return label.match(filter) || [""];
      },
      // Sets ticks on custom set of intervals based on axis width, minimum pixels between ticks,
      // and data min/max. Also works for intervals outide the range of the intervals array.
      //
      // Returns: array containing the tick positions
      // Parameters:
      //  length: axis length in pixels
      //  minPixels: the minimum pixels desired between ticks
      //  dataMin, dataMax: the min/max data values to be displayed
      //  customIntervals: (optional) array of tick intervals to choose from.
      //                   **Must begin and end with a power of 10**.
      //
      tickPositioner: function tickPositioner(length, minPixels, dataMin, dataMax, customIntervals) {
        var intervals = customIntervals || [0.1, 0.20, 0.25, 0.5, 1, 2, 5, 10, 25, 50, 100, 200, 500, 1000],
          lower = _.first(intervals),
          upper = _.last(intervals),
          nIntervals = Math.floor(length / minPixels),
          interval = (dataMax - dataMin) / nIntervals,
          scale = 1.0,
          positions = [];
        if (interval === 0) {
          return dataMax !== null ? [dataMax] : positions;
        }

        // scale interval to be within the range of values in intervals array
        var scaleUp = interval < lower ? true : false;
        while (interval < lower || interval > upper) {
          scale = scale * 10;
          interval = scaleUp ? interval * 10 : interval / 10;
        }
        // constrain interval to an allowed value in intervals array
        interval = intervals[_.sortedIndex(intervals, interval)];

        // scaling implemented this way to avoid js floating-point roundoff error
        while (interval < 1) {
          scaleUp = true;
          scale = scale * 10;
          interval = interval * 10;
        }
        dataMin = scaleUp ? dataMin * scale : dataMin / scale;
        dataMax = scaleUp ? dataMax * scale : dataMax / scale;

        // determine starting tick
        var tick = Math.floor(dataMin / interval) * interval;

        // return list of ticks
        for (tick; tick < dataMax + interval; tick += interval) {
          positions.push(scaleUp ? tick / scale : tick * scale);
        }
        return positions;
      },
      getSeriesColor: function getSeriesColor(config, i, defaultColor, measure) {
        //return null if no default color
        defaultColor = defaultColor || null;
        config = config || {};
        //card specific color
        if (config.colors && config.colors.length > i) {
          return config.colors[i];
        }
        //measure specific color
        if (measure && measure.color) {
          return measure.color;
        }
        var settings = OrganizationSettings.getSettingsSync();
        if (settings.colors && settings.colors.length > i) {
          return settings.colors[i];
        }

        //return default color, if null this will use highcharts defaults
        return defaultColor;
      },
      tooltipContent: function tooltipContent(measureName, displayValue) {
        return "<td>".concat(measureName, ":</td><td>").concat(displayValue, "</td>");
      },
      // dirty DOM manipulation >;)
      // because highcharts makes a new tooltip and attaches to body for every card :-(
      clearTooltips: function clearTooltips() {
        angular.element.find(".highcharts-tooltip-container").forEach(function (e) {
          return e.remove();
        });
      }
    };
  }]);
})();
